import { render, staticRenderFns } from "./EstadoCuenta.vue?vue&type=template&id=850b49d0&"
import script from "./EstadoCuenta.vue?vue&type=script&lang=js&"
export * from "./EstadoCuenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports